//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Content from '~sdp-components/PageElements/Content.vue'
import PlusMinusIcon from '~sdp-components/Icons/PlusMinusIcon'
import SearchIcon from '~sdp-components/Icons/SearchIcon'
import ClearIcon from '~sdp-components/Icons/ClearIcon'

export default {
  components: {
    // Content,
    PlusMinusIcon,
    SearchIcon,
    ClearIcon
  },
  props: {
    // required
    /**
     * Can be an array of values (which will be displayed) or a key-value map of values and labels
     */
    dropdownOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: [Array, Object],
      required: true
    },

    // optional
    label: {
      type: String,
      required: false,
      default: ''
    },
    selectedValue: {
      type: [String, Number],
      required: false,
      default: null
    },
    optionsMaxHeight: {
      type: [String, Number],
      required: false,
      default: '16rem'
    },
    textClasses: {
      type: String,
      required: false,
      default: ''
    },
    buttonOnLeft: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      value: null,
      filterText: ''
    }
  },
  computed: {
    /** The current label **/
    selectedLabel() {
      if (Array.isArray(this.options)) {
        const match = this.options.filter(({ value }) => value === this.value)
        return match.length ? match[0].label : ''
      } else {
        return this.options[this.value]
      }
    },
    valueArray() {
      if (Array.isArray(this.options)) {
        if (this.options.length > 0) {
          const firstVal = this.options[0]
          // are values in array primitive or value/label
          if (typeof firstVal === 'object') {
            try {
              return this.options.map(v => v.value)
            } catch (e) {
              throw new Error(
                "Dropdown options, organized as an array, should include an object with 'value', and optionally 'label'",
                e
              )
            }
          } else {
            return this.options
          }
        } else {
          return []
        }
      } else {
        return Object.keys(this.options)
      }
    },
    labelArray() {
      if (Array.isArray(this.options)) {
        if (this.options.length > 0) {
          const firstVal = this.options[0]
          // are values in array primitive or value/label
          if (typeof firstVal === 'object') {
            try {
              return this.options.map(v => (v.label ? v.label : v.value))
            } catch (e) {
              throw new Error(
                "ButtonGroup options, organized as an array, should include an object with 'value', and optionally 'label'",
                e
              )
            }
          } else {
            return this.options
          }
        } else {
          return []
        }
      } else {
        return Object.keys(this.options).map(o => this.options[o])
      }
    },
    filteredValueArray() {
      const arr = this.labelArray
        .map((label, index) => ({
          label,
          value: this.valueArray[index]
        }))
        .filter(({ label }) =>
          label.toLowerCase().includes(this.filterText.toLowerCase())
        )
      return arr.map(({ value }) => value)
    },
    filteredLabelArray() {
      const arr = this.labelArray
        .map((label, index) => ({
          label,
          value: this.valueArray[index]
        }))
        .filter(({ label }) =>
          label.toLowerCase().includes(this.filterText.toLowerCase())
        )
      return arr.map(({ label }) => label)
    }
  },
  watch: {
    selectedValue() {
      this.value = this.selectedValue
    }
  },
  mounted() {
    this.value =
      this.selectedValue != null ? this.selectedValue : this.valueArray[0]
  },
  methods: {
    updateSelected(value, label) {
      this.dropdownOpen = false
      this.value = value
      this.$emit('selected', { value, label })
    }
  }
}
